/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendConfirmUserPhoneRequest
 */
export interface SendConfirmUserPhoneRequest {
    /**
     * 
     * @type {string}
     * @memberof SendConfirmUserPhoneRequest
     */
    phone: string;
}

/**
 * Check if a given object implements the SendConfirmUserPhoneRequest interface.
 */
export function instanceOfSendConfirmUserPhoneRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "phone" in value;

    return isInstance;
}

export function SendConfirmUserPhoneRequestFromJSON(json: any): SendConfirmUserPhoneRequest {
    return SendConfirmUserPhoneRequestFromJSONTyped(json, false);
}

export function SendConfirmUserPhoneRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendConfirmUserPhoneRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phone': json['phone'],
    };
}

export function SendConfirmUserPhoneRequestToJSON(value?: SendConfirmUserPhoneRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phone': value.phone,
    };
}

